import { defaultIconProps, IconProps } from './IconProps';

export const IconRemove: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <circle cx="12" cy="12" r="9" stroke={color} />
    <path d="M7.5 12H16.5" stroke={color} />
  </svg>
);

IconRemove.defaultProps = defaultIconProps;
